import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TimerService {
  isVisible!: boolean;
  targetDuration = 0;
  status$ = new BehaviorSubject<'stopped' | 'running' | 'paused'>('stopped');
  private startTime!: number;
  private savedDuration!: number;
  private pauseTimestamp?: number;

  start(targetDuration: number, { savedDuration = 0, isVisible = true } = {}) {
    this.targetDuration = targetDuration;
    this.startTime = performance.now();
    this.savedDuration = savedDuration;
    this.isVisible = isVisible;
    this.pauseTimestamp = undefined;
    this.status$.next('running');
  }

  elapsed(until = this.pauseTimestamp ?? performance.now()) {
    return (until - this.startTime) / 1000 + this.savedDuration;
  }

  resume() {
    if (this.status$.value === 'running') {
      return;
    }
    this.savedDuration = this.elapsed(this.pauseTimestamp);
    this.startTime = performance.now();
    this.pauseTimestamp = undefined;
    this.status$.next('running');
  }

  pause(timestamp?: number) {
    if (this.status$.value === 'paused') {
      return;
    }
    this.pauseTimestamp = timestamp;
    this.status$.next('paused');
  }

  getStatus() {
    return this.status$.value;
  }
}
